import AiLogo from "../../images/ai.png";
import AjaxLogo from "../../images/ajax.png";
import AngularLogo from "../../images/angular.png";
import ApacheSparkLogo from "../../images/apache_spark.png";
import AppleLogo from "../../images/apple.png";
import Appollo1 from "../../images/appolo.jpeg";
import ArcoreLogo from "../../images/arcore.jpeg";
import Arkit from "../../images/arkit.jpeg";
import Asp1 from "../../images/aspcore.png";
import Avalonia from "../../images/avalonia.jpeg";
import AwsLogo from "../../images/aws.jpeg";
import AzureLogo from "../../images/azure.jpeg";
import BabylonjsLogo from "../../images/babylonjs.jpeg";
import BackendLogo from "../../images/backend.jpeg";
import BashLogo from "../../images/bash.jpeg";
import BootstrapLogo from "../../images/bootsrap.jpeg";
import CppLogo from "../../images/c++.png";
import CLanguge from "../../images/C.png";
import CICD from "../../images/ci.jpeg";
import Cocoapods from "../../images/cocopods.png";
import CodingGeneral from "../../images/coding.png";
import AppLogo from "../../images/logo_sm.png";
import CryEngine from "../../images/cryengine.png";
import Csharp from "../../images/cshap.png";
import CssLogo from "../../images/css_2.png";
import Cybersecurity from "../../images/cybersecurity.jpeg";
import DartLogo from "../../images/dart.png";
import DevOps from "../../images/devOps.jpeg";
import DjangoLogo from "../../images/django.png";
import DockerLogo from "../../images/docker.png";
import DrupalLogo from "../../images/drupal.png";
import DynamoDBLogo from "../../images/dynamoDB.png";
import ElectronJsLogo from "../../images/eletron.png";
import EmbeddedSystem from "../../images/embedded.png";
import ErlangLogo from "../../images/erlang.png";
import pythonFastApi from "../../images/fastAPI.png";
import PythonFlask from "../../images/flask.png";
import FlutterLogo from "../../images/flutter.png";
import DigitalForensics from "../../images/forensics.png";
import Frontend from "../../images/frontends.png";
import FsharpLogo from "../../images/fsharp.png";
import GithubActions from "../../images/g_actions.png";
import GatsbyLogo from "../../images/gatsby.png";
import GCPLogo from "../../images/gcp_1.png";
import GitlabLogo from "../../images/gitlab2.png";
import GoLanguage from "../../images/Go.png";
import GodotLogo from "../../images/godot.png";
import GoogleLogo from "../../images/google.png";
import GraphQLogo from "../../images/graph.png";
import GraphicDesign from "../../images/graphic_design.jpeg";
import HTMLCSSLogo from "../../images/html_css.webp";
import IonicLogo from "../../images/ionic.png";
import IoTLogo from "../../images/iot2.png";
import JavaLogo from "../../images/java.png";
import JavascriptLogo from "../../images/javascript.png";
import JenkinsLogo from "../../images/jenkins.png";
import JetpakCompose from "../../images/jetpakcompose.png";
import JquerryLogo from "../../images/jquery.png";
import PythonKivyLogo from "../../images/kivy.png";
import KMM from "../../images/kmp.png";
import KotlinLogo from "../../images/Kotlin.png";
import KuberLogo from "../../images/kuber.jpeg";
import LaravelLogo from "../../images/laravel.png";
import LbgdxLogo from "../../images/lbgdx.png";
import LinuxLogo from "../../images/linux.jpeg";
import MatplotlibLogo from "../../images/matplotlib.png";
import MauiLogo from "../../images/maui.png";
import MeteorLogo from "../../images/meteor.png";
import MicrosoftLogo from "../../images/microsoft.png";
import MobileAndroid from "../../images/mobile_andro.png";
import MongoLogo from "../../images/mongo.png";
import MonoGameLogo from "../../images/monogame.png";
import MySQLogo from "../../images/mysql.png";
import NetworkingLogo from "../../images/networking.png";
import NodeLogo from "../../images/node.png";
import NumpyLogo from "../../images/numpy.png";
import ObjectiveClogo from "../../images/objective_c.png";
import PandasLogo from "../../images/pandas.png";
import PHPLogo from "../../images/php_1.png";
import PostgresLogo from "../../images/postgres.png";
import PowershelLogo from "../../images/powershel.png";
import PythonLogo from "../../images/python.jpeg";
import ReactLogo from "../../images/react.png";
import ReverseEngineerLogo from "../../images/reverse_2.png";
import RubyLogo from "../../images/ruby.jpg";
import RustLanguageLogo from "../../images/rust.png";
import S3BucketAWSLogo from "../../images/s3.jpeg";
import ScalaLogo from "../../images/scala.png";
import ScikitLernLogo from "../../images/scikit.png";
import SeabornLogo from "../../images/seaborn2.png";
import SeleniumLogo from "../../images/selenium.png";
import SpringBootLogo from "../../images/spring.png";
import SqliteLogo from "../../images/sqlite.png";
import SwiftLogo from "../../images/swift1.png";
import TailwindCSS from "../../images/tailwind.png";
import TensorflowLogo from "../../images/tensorflow.png";
import TerraformLogo from "../../images/terra.png";
import ThreeJsLogo from "../../images/threejs.png";
import TravisCILogo from "../../images/travis.png";
import TypescriptLogoLogo from "../../images/typescript.png";
import UIUXLogo from "../../images/ui.png";
import UnityLogo from "../../images/unity.png";
import UnrealEngineLogo from "../../images/unrealEngine.png";
import VueLogo from "../../images/vue.png";
import WinformsLogo from "../../images/winforms.jpeg";
import WordPressLogo from "../../images/wordpress.png";
import XamarinLogo from "../../images/xamarin2.png";

// latest added
import AdobeXD from "../../images/adobeXD.png";
import Adonisjs from "../../images/adonis.png";
import Aerospike from "../../images/aerospike.png";
import Aframe from "../../images/aframe.png";
import Alchemy from "../../images/alchemy.jpeg";
import Algolia from "../../images/algolia.png";
import Alpinejs from "../../images/alpine.png";
import Ansible from "../../images/ansible.png";
import ApacheDrill from "../../images/apache_dril1.jpeg";
import ApacheIgnite from "../../images/apache_ignite.png";
import ApacheSolr from "../../images/apache_solr.png";
import Arrango from "../../images/arango.jpeg";
import ArgoCI from "../../images/argo.png";
import AssemlyLang from "../../images/assembly_logo.png";
import Atlasian from "../../images/atlasian.png";
import AzureCosmos from "../../images/aurecosmos.jpeg";
import AWS_Code_Pipeline from "../../images/aws_codepipe.png";
import AWS_Timestream from "../../images/aws_timestream.jpeg";
import AWSAurora from "../../images/awsAurora.jpeg";
import AWSDocumentDB from "../../images/awsdocu.jpeg";
import AWSLambayard from "../../images/awslamba.png";
import AWSNeptune from "../../images/awsneptune.jpeg";
import AWSRDS from "../../images/awsRDS.png";
import AzureDevOps from "../../images/azureDevOps.png";
import Balsmiq from "../../images/balsmiq.png";
import Bamboo from "../../images/bamboo.jpeg";
import Bitbucket from "../../images/bitbucket.png";
import BitbucketPipe from "../../images/bitbucketpipe.png";
import Bitcoin from "../../images/bitcoin.png";
import Blender from "../../images/blender.png";
import Blueprint from "../../images/blueprint.jpeg";
import Buddy from "../../images/budy.png";
import Capacitor from "../../images/capacitor.png";
import Cassandra from "../../images/cassandra.png";
import Cayley from "../../images/cayley.png";
import CloudGenral from "../../images/cloud.png";
import CockroachDB from "../../images/cockroachdb.jpeg";
import Codefresh from "../../images/codefresh.png";
import CodeIgniter from "../../images/codeigniter.png";
import Containerisation from "../../images/containerisation.png";
import Cordova from "../../images/cordova.png";
import CoronaSDK from "../../images/coronasdk.png";
import CouchDB from "../../images/couchDB.png";
import Craft from "../../images/craft.png";
import Createjs from "../../images/createjs.png";
import Cryptocurrency from "../../images/crypto.jpeg";
import Dlang from "../../images/D.jpeg";
import D3js from "../../images/d3js.png";
import DataScience from "../../images/data_science.png";
import Datasax from "../../images/datasax.jpeg";
import DefaultHosting from "../../images/default_host.png";
import Defold from "../../images/defold.jpeg";
import Dgraph from "../../images/dgraph.jpeg";
import DolphineDB from "../../images/dolpine.png";
import ElasticSearch from "../../images/elastic_search.png";
import Etherium from "../../images/etherium.png";
import MSExcel from "../../images/excel.png";
import FaunaDB from "../../images/fauna.png";
import Figma from "../../images/figma.png";
import FirebaseDB from "../../images/firebase.png";
import Firebird from "../../images/firebird.jpeg";
import FlowMap from "../../images/flowmap.png";
import FoundationDB from "../../images/foundationDB.png";
import Framer from "../../images/framer.png";
import Framework7 from "../../images/framework7.png";
import GenralDB from "../../images/genralDB.jpeg";
import GitHub from "../../images/github.png";
import GoogleBigTable from "../../images/google_bigtable.png";
import GoogleCloudBuild from "../../images/google_cloud_build.png";
import GoogleCloudSQL from "../../images/google_cloud_sql.png";
import GoogleCloudSpanner from "../../images/google_spanner.png";
import Gradle from "../../images/gradle.png";
import Grafana from "../../images/grafana.png";
import GraphiteDB from "../../images/graphiteDB.png";
import GTK from "../../images/gtk.png";
import Hacker from "../../images/hacker.png";
import Hanami from "../../images/hanami.png";
import Harness from "../../images/harness.png";
import HaskelLang from "../../images/haskel.png";
import HazelCast from "../../images/hazelcast.png";
import HBase from "../../images/hbase.png";
import Heroku from "../../images/heroku.png";
import Hypertable from "../../images/hypertable.jpeg";
import IBM from "../../images/ibm.png";
import IBMDB from "../../images/ibmdb.png";
import AdobeIllustrator from "../../images/illustrator.png";
import InfluxDB from "../../images/influx.png";
import InVision from "../../images/invision.png";
import JanusGraph from "../../images/janusgraph.png";
import JavaFX from "../../images/javafx.png";
import Jira from "../../images/jira.jpeg";
import Justinmind from "../../images/justinmind.png";
import KenHost from "../../images/kenHost.png";
import KerasLogo from "../../images/keras.png";
import KeyDB from "../../images/keyDB.png";
import KoaJS from "../../images/koajs.png";
import Lightnode from "../../images/lightnode.jpeg";
import Lisp from "../../images/lisp.jpeg";
import Lua from "../../images/lua.png";
import LucidChart from "../../images/lucidchart.jpeg";
import Meilsearch from "../../images/meilisearch.jpeg";
import MelonJs from "../../images/melonjs.png";
import MemcacheDB from "../../images/memcache.jpeg";
import MemGraphDB from "../../images/memgraph.jpeg";
import MemSQL from "../../images/memsql.jpeg";
import Metasploit from "../../images/metasploit.png";
import MicrosoftSQL from "../../images/microsoftsql.png";
import Mpesa from "../../images/mpesa.png";
import NativeScript from "../../images/native_script.png";
import Neo4JDB from "../../images/neo4j.png";
import Nestjs from "../../images/nestjs.png";
import Netlify from "../../images/netlify.png";
import Nextjs from "../../images/nextjs.png";
import NLP from "../../images/nlp.png";
import NLTK from "../../images/nltk.png";
import NuoDB from "../../images/nuoDB.png";
import NuxtJs from "../../images/nuxtjs.png";
import Nvidia from "../../images/nvidia.png";
import ObjectDB from "../../images/objectdb.png";
import DigitalOCean from "../../images/ocean.png";
import MsOffice from "../../images/office.jpeg";
import OpenTSB from "../../images/office2.jpeg";
import MsOffice365 from "../../images/openTSB.png";
import OracleCloudant from "../../images/oracle_cloudant.png";
import OracleNoSQL from "../../images/oracle_nosql.png";
import OrientDB from "../../images/orientdb.png";
import Paypal from "../../images/paypal2.png";
import PayTM from "../../images/paytm.png";
import Percona from "../../images/percona.jpeg";
import Phaserjs from "../../images/phaserjs.jpeg";
import AdobePhotoshop from "../../images/photoshop.jpeg";
import PineConeDB from "../../images/pinecondb.png";
import PlanetScaleDB from "../../images/planetscaledb.png";
import PlatformEngineer from "../../images/platform.png";
import PlayCanvas from "../../images/playcanvas.jpeg";
import PowerBi from "../../images/powerBI.jpeg";
import Preact from "../../images/preact.png";
import ProtoIO from "../../images/protoio.png";
import Puppet from "../../images/puppet.png";
import PyGame from "../../images/pygame.png";
import Pyramid from "../../images/pyramid.png";
import Pytorch from "../../images/pytorch.png";
import Rails from "../../images/rails.png";
import ReactNative from "../../images/reactnative.jpeg";
import RecoilState from "../../images/recoil.png";
import Reddis from "../../images/redis.png";
import ReduxLogo from "../../images/redux.png";
import Remix from "../../images/remix.jpeg";
import RendersLogo from "../../images/render.png";
import RethinkDB from "../../images/rethink.png";
import RiakDb from "../../images/riak.png";
import RLang from "../../images/rprogram.jpeg";
import RRD from "../../images/rrd.jpeg";
import Safaricom from "../../images/safaricom.png";
import SapHana from "../../images/sap_hana.jpeg";
import ScyllaDB from "../../images/scyllaDB.png";
import Semapho from "../../images/semapho.png";
import Sinatra from "../../images/sinatra.jpeg";
import Solidity from "../../images/solidity.jpeg";
import Spinnaker from "../../images/spinnaker.jpeg";
import Spritekit from "../../images/spritekit.jpeg";
import SQLGenral from "../../images/sql.jpeg";
import Streamlit from "../../images/streamlit.png";
import Stripe from "../../images/stripe.jpeg";
import Supabase from "../../images/supabase.jpeg";
import Surreal from "../../images/surrealDB.png";
import Svelte from "../../images/svlete.png";
import Sybase from "../../images/sybase.jpeg";
import Symfony from "../../images/symfony.png";
import Tableu from "../../images/tableu.png";
import TaranTool from "../../images/taran.png";
import Tauri from "../../images/tauri.png";
import TBCO from "../../images/tbco.jpeg";
import TeamCity from "../../images/teamcity.png";
import TiDB from "../../images/tidb.png";
import TigerGraph from "../../images/tiger_graph.png";
import TimescaleDB from "../../images/timescale.jpeg";
import TrueHost from "../../images/truehost.png";
import Uxpin from "../../images/uxpin.png";
import Vercel from "../../images/vercel.png";
import VersantDB from "../../images/versantdb.jpeg";
import VISA from "../../images/visa.png";
import VoltDB from "../../images/voltdb.png";
import Vuforia from "../../images/vuforia.png";
import Web3 from "../../images/web3.jpeg";
import Webflow from "../../images/webflow.png";
import MsWord from "../../images/word.png";
import WxPy from "../../images/wxPython.jpeg";
import YugaByteDB from "../../images/yugaByte.png";
import Zustand from "../../images/zustand.png";


const imageMap = {
  Metatron: AppLogo,
  Zustand: Zustand,
  "YugaByte DB": YugaByteDB,
  WxPython: WxPy,
  Word: MsWord,
  Webflow: Webflow,
  Web3: Web3,
  Vuforia: Vuforia,
  VoltDB: VoltDB,
  VISA: VISA,
  VersantDB: VersantDB,
  Vercel: Vercel,
  UXpin: Uxpin,
  Truehost: TrueHost,
  "Timescale DB": TimescaleDB,
  "TigerGraph DB": TigerGraph,
  TiDB: TiDB,
  TeamCity: TeamCity,
  Tauri: Tauri,
  "TIBCO Visualization": TBCO,
  "Taran Tool": TaranTool,
  Tableu: Tableu,
  Symfony: Symfony,
  Sybase: Sybase,
  Svelte: Svelte,
  "Surreal DB": Surreal,
  Supabase: Supabase,
  Stripe: Stripe,
  Streamlit: Streamlit,
  SQL: SQLGenral,
  Spritekit: Spritekit,
  Spinnaker: Spinnaker,
  Solidity: Solidity,
  Sinatra: Sinatra,
  Semaphore: Semapho,
  "Scylla DB": ScyllaDB,
  "Sap Hana": SapHana,
  Safaricom: Safaricom,
  RRD: RRD,
  "R Programming": RLang,
  "Riak DB": RiakDb,
  "Rethink DB": RethinkDB,
  Renders: RendersLogo,
  Remix: Remix,
  Redux: ReduxLogo,
  Reddis: Reddis,
  Recoil: RecoilState,
  ReactNative: ReactNative,
  "Ruby on Rails": Rails,
  Pytorch: Pytorch,
  Pyramid: Pyramid,
  Pygame: PyGame,
  Puppet: Puppet,
  "Proto.io": ProtoIO,
  Preact: Preact,
  PowerBi: PowerBi,
  PlayCanvas: PlayCanvas,
  "Platform Engineer": PlatformEngineer,
  "PlanetScale DB": PlanetScaleDB,
  PineConeDB: PineConeDB,
  Phaserjs: Phaserjs,
  "Percona Server": Percona,
  PayTM: PayTM,
  PayPal: Paypal,
  "Orient DB": OrientDB,
  "Oracle NoSQL": OracleNoSQL,
  "Oracle CLoudant": OracleCloudant,
  "Open TSDB": OpenTSB,
  "Microsoft Office 365": MsOffice365,
  "Microsoft Office": MsOffice,
  "Digital Ocean": DigitalOCean,
  ObjectDB: ObjectDB,
  "Cuda-Nvidia": Nvidia,
  Nuxt: NuxtJs,
  NuoDB: NuoDB,
  NLTK: NLTK,
  NLP: NLP,
  Next: Nextjs,
  Netlify: Netlify,
  Nestjs: Nestjs,
  "Neo4j DB": Neo4JDB,
  Mpesa: Mpesa,
  "Native Script": NativeScript,
  "Microsoft SQL": MicrosoftSQL,
  Metasploit: Metasploit,
  MemSQL: MemSQL,
  MemGraph: MemGraphDB,
  MemCacheDB: MemcacheDB,
  Melonjs: MelonJs,
  "MeiliSearch DB": Meilsearch,
  LucidChart: LucidChart,
  Lua: Lua,
  Lisp: Lisp,
  LightNode: Lightnode,
  Koajs: KoaJS,
  KeyDB: KeyDB,
  Keras: KerasLogo,
  KenHost: KenHost,
  Justinmind: Justinmind,
  Jira: Jira,
  JavaFX: JavaFX,
  "JanausGraph DB": JanusGraph,
  Invision: InVision,
  InfluxDB: InfluxDB,
  "IBM DB2": IBMDB,
  IBM: IBM,
  HyperTable: Hypertable,
  Heroku: Heroku,
  "HBase DB": HBase,
  "Hazelcast DB": HazelCast,
  Haskell: HaskelLang,
  "Harness DevOps": Harness,
  Hanami: Hanami,
  Hacker: Hacker,
  GTK: GTK,
  "Graphite DB": GraphiteDB,
  Grafana: Grafana,
  Gradle: Gradle,
  "Google Cloud SQL": GoogleCloudSQL,
  "Google Cloud Build": GoogleCloudBuild,
  "Google Spanner": GoogleCloudSpanner,
  "Google Bigtable": GoogleBigTable,
  "Google Cloud Platform":GCPLogo,
  Database: GenralDB,
  Framework7: Framework7,
  Framer: Framer,
  "Foundation DB": FoundationDB,
  FlowMap: FlowMap,
  Firebird: Firebird,
  Firebase: FirebaseDB,
  Figma: Figma,
  "Fauna DB": FaunaDB,
  Excel: MSExcel,
  Etherium: Etherium,
  "Elastic Search DB": ElasticSearch,
  "Dolphine DB": DolphineDB,
  "Dgraph DB": Dgraph,
  Defold: Defold,
  "Web Hosting": DefaultHosting,
  Datasax: Datasax,
  DataScience: DataScience,
  D3js: D3js,
  "D Programming": Dlang,
  Cryptocurrency: Cryptocurrency,
  CreateJs: Createjs,
  Craft: Craft,
  CouchDB: CouchDB,
  "Corona SDK": CoronaSDK,
  Cordova: Cordova,
  Containerisation: Containerisation,
  CodeIgniter: CodeIgniter,
  "Cassandra DB": Cassandra,
  "Cayley DB": Cayley,
  "Cockroach DB": CockroachDB,
  "Cloud Computing": CloudGenral,
  CodeFresh: Codefresh,
  Bamboo: Bamboo,
  Bitbucket: Bitbucket,
  "Bitbucket Codepipeline": BitbucketPipe,
  Bitcoin: Bitcoin,
  Blender: Blender,
  Blueprint: Blueprint,
  Buddy: Buddy,
  "Adobe XD": AdobeXD,
  "Adobe Illustrator": AdobeIllustrator,
  "Adobe Photoshop": AdobePhotoshop,
  Adonisjs: Adonisjs,
  "Aerospike DB": Aerospike,
  Aframe: Aframe,
  "Alchemy Web3": Alchemy,
  Algolia: Algolia,
  Alpine: Alpinejs,
  Ansible: Ansible,
  "Apache Drill": ApacheDrill,
  "Apache Ignite": ApacheIgnite,
  "Apache Solr": ApacheSolr,
  "Arrango DB": Arrango,
  "Argo CI": ArgoCI,
  Assembly: AssemlyLang,
  Atlasian: Atlasian,
  "Azure Cosmos": AzureCosmos,
  "AWS CodePipeline": AWS_Code_Pipeline,
  "Amazon Timestream": AWS_Timestream,
  "Amazon Web Services": AwsLogo,
  "Amazon Aurora": AWSAurora,
  "Amazon DocumentDB": AWSDocumentDB,
  "Amazon Lamberyard": AWSLambayard,
  "Amazon Neptune": AWSNeptune,
  "Amazon RDS": AWSRDS,
  "Azure DevOps": AzureDevOps,
  "Amazon DynamoDB": DynamoDBLogo,
  Balsamiq: Balsmiq,
  Capacitor:Capacitor,
  // old
  Ruby: RubyLogo,
  Android: MobileAndroid,
  IOS: AppleLogo,
  AWS: AwsLogo,
  Node: NodeLogo,
  Python: PythonLogo,
  React: ReactLogo,
  Kotlin: KotlinLogo,
  "Kotlin Multiplatform": KMM,
  Java: JavaLogo,
  Jenkins: JenkinsLogo,
  Coding: CodingGeneral,
  "C++": CppLogo,
  Ajax: AjaxLogo,
  Azure: AzureLogo,
  Bootstrap: BootstrapLogo,
  Angular: AngularLogo,
  Vue: VueLogo,
  TypeScript: TypescriptLogoLogo,
  Swift: SwiftLogo,
  SQLite: SqliteLogo,
  PostgreSQL: PostgresLogo,
  PHP: PHPLogo,
  "Microsoft Azure":AzureLogo,
  MySQL: MySQLogo,
  Meteor: MeteorLogo,
  MongoDB: MongoLogo,
  AI: AiLogo,
  Linux: LinuxLogo,
  JavaScript: JavascriptLogo,
  HTML: HTMLCSSLogo,
  Cybersecurity: Cybersecurity,
  "Apache Spark": ApacheSparkLogo,
  Appollo: Appollo1,
  Arcore: ArcoreLogo,
  Arkit: Arkit,
  "ASP.NET": Asp1,
  Avalonia: Avalonia,
  Babylon: BabylonjsLogo,
  Backend: BackendLogo,
  Bash: BashLogo,
  "Bash/Shell": BashLogo,
  C: CLanguge,
  "CI/CD": CICD,
  CocoaPods: Cocoapods,
  CSS: CssLogo,
  CryEngine: CryEngine,
  "C#": Csharp,
  Dart: DartLogo,
  DevOps: DevOps,
  Django: DjangoLogo,
  Docker: DockerLogo,
  Drupal: DrupalLogo,
  Electron: ElectronJsLogo,
  Embedded: EmbeddedSystem,
  Erlang: ErlangLogo,
  FastAPI: pythonFastApi,
  Flask: PythonFlask,
  Flutter: FlutterLogo,
  Forensics: DigitalForensics,
  Frontend: Frontend,
  "F#": FsharpLogo,
  "GitHub Actions": GithubActions,
  Gatsby: GatsbyLogo,
  GCP: GCPLogo,
  GitLab: GitlabLogo,
  Go: GoLanguage,
  Godot: GodotLogo,
  Google: GoogleLogo,
  GraphQL: GraphQLogo,
  "Graphic Design": GraphicDesign,
  Ionic: IonicLogo,
  IoT: IoTLogo,
  JetpackCompose: JetpakCompose,
  JQuery: JquerryLogo,
  Kivy: PythonKivyLogo,
  Kubernetes: KuberLogo,
  Laravel: LaravelLogo,
  LibGDX: LbgdxLogo,
  Matplotlib: MatplotlibLogo,
  MAUI: MauiLogo,
  Microsoft: MicrosoftLogo,
  MonoGame: MonoGameLogo,
  Networking: NetworkingLogo,
  NumPy: NumpyLogo,
  "Objective-C": ObjectiveClogo,
  Pandas: PandasLogo,
  PowerShell: PowershelLogo,
  "Reverse Engineer": ReverseEngineerLogo,
  Rust: RustLanguageLogo,
  S3: S3BucketAWSLogo,
  Scala: ScalaLogo,
  "Scikit-learn": ScikitLernLogo,
  Seaborn: SeabornLogo,
  Selenium: SeleniumLogo,
  "Spring Boot": SpringBootLogo,
  Tailwind: TailwindCSS,
  TensorFlow: TensorflowLogo,
  Terraform: TerraformLogo,
  Threejs: ThreeJsLogo,
  "Travis CI": TravisCILogo,
  "UI/UX": UIUXLogo,
  Unity: UnityLogo,
  "Unreal Engine": UnrealEngineLogo,
  WinForms: WinformsLogo,
  WordPress: WordPressLogo,
  Xamarin: XamarinLogo,
  "GitHub":GitHub,
  "Containers":KuberLogo,
  "Data Analyst":PowerBi,
  "Data Science":DataScience,
  "Desktop":ElectronJsLogo,
  "Game":UnrealEngineLogo,
  "HTML and CSS":HTMLCSSLogo,
  "Mobile":MobileAndroid,
  "Computer Networks":NetworkingLogo,
  "Golang":GoLanguage,
  "React Native":ReactNative,
  "Python Programming Community":PythonLogo,
  "PHP Programming Community":PHPLogo,
  "React and Next Community":ReactLogo,
  "Angular Community":AngularLogo,
  "Svelte Community":Svelte,
  "Vue Community":VueLogo,
  "Assembly Community":AssemlyLang,
};

// Utility to get the corresponding image
export const getImageMatch = (title = "", isAll = false, isAny=false) => {
  if (isAll) {
    const matchingKey = Object.keys(imageMap)
      .sort()
      .filter((key) => key.length > 0);
    const values = Object.keys(imageMap)
      .sort()
      .map((key) => imageMap[key]);
    return [matchingKey, values];
  } else if (isAny) {
     const matchingKey = Object.keys(imageMap).filter((key)=>{
      let tempKey=''
      if (title.includes(key)) {
        tempKey=key
      }

      return tempKey
    })
    // Default logo if no match
    return matchingKey ? imageMap[matchingKey] : CodingGeneral;
  }
  else {
    const matchingKey = Object.keys(imageMap).find(
      (key) => title?.trim()?.toLowerCase() === key?.trim()?.toLowerCase()
    );
    // Default logo if no match
    return matchingKey ? imageMap[matchingKey] : CodingGeneral;
  }
};
